import axios from "axios";
import ProfileDetails from "../profileComponents/ProfileDetails";
import Form from "../profileComponents/Form";
import classes from "../../pages/MyProfile.module.scss";
import LoadingDots from "../UI/LoadingDots";
import { useState, useRef, useEffect, useContext, useCallback } from "react";
import { DDD, E2Data} from "../../lib/ddd/ddd";
import { useQuery } from '@tanstack/react-query'

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);
const e2Data = new E2Data("Countries");
e2Data.format="Full";
e2Data.filter = "EinvoicesOrder <> null";
e2Data.orderBy = "EinvoicesOrder asc, CountryNameOriginal asc";
e2Data.take = null;

const e2DataCurrency = new E2Data("common/Currencies");
e2DataCurrency.format="Full";
e2DataCurrency.take = 1000;

const e2EntityInfo = new E2Data("EU_AOrg");
e2EntityInfo.format="Full";

const e2OrgData = new E2Data("EU_AOrg");

const Profile = ({hideSave, saveRef}) => {
  const [profileData, setProfileData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(null);
  const [isEditMode, setIsEditMode] = useState(true);
  const [countriesList, setCountriesList] = useState([]);
  const [currenciesList, setCurrenciesList] = useState([]);
  const [entityInfo, setEntityInfo] = useState(null);

  /*const transDataArgs = { type : "profile" };
  const {isPending : isTransformerPending, data : transformerData} = useQuery({
    queryKey: ['EUeInvoices.GetTransformerData', transDataArgs],
    queryFn: () => ddd.Rpc_ExecuteExtension("EUeInvoices.GetTransformerData", transDataArgs)
  })*/

  const {isPending : isOrgPending, data : orgData, refetch} = useQuery({
    queryKey: ['Data.GetEntityData', e2OrgData.GetParamsObject()],
    queryFn: () => e2OrgData.GetData(),
  })
  
  const {isPending : isInfoPending, data : entityInfoData} = useQuery({
    queryKey: ['Data.GetEntityInfo', e2EntityInfo.GetParamsObject()],
    queryFn: () => e2EntityInfo.GetEntityInfo(),
    staleTime: Infinity
  })
  
  const {isPending : isDataPending, data : countriesData} = useQuery({
    queryKey: ['Data.GetEntityData', e2Data.GetParamsObject()],
    queryFn: () => e2Data.GetData(),
    staleTime: Infinity
  })

  const {isPending : isCurrencyDataPending, data : currencyData} = useQuery({
    queryKey: ['Data.GetEntityData', e2DataCurrency.GetParamsObject()],
    queryFn: () => e2DataCurrency.GetData(),
    staleTime: Infinity
  })


  useEffect(() => {
    if(!isOrgPending){
        let data = {};
        data.org = orgData.result?.data[0];
        setProfileData(data);
        setIsLoaded(true);
    }
    /*if(!isTransformerPending){
        console.log(transformerData);
        setProfileData(transformerData.result?.Result);
        setIsLoaded(true);
    }*/
    if(!isDataPending){
        //console.log(countriesData.result?.data);
        setCountriesList(countriesData.result?.data);
    }
    if(!isCurrencyDataPending){
      setCurrenciesList(currencyData?.result?.data || []);
    }

    if(!isInfoPending)
      setEntityInfo(entityInfoData?.result);

  }, [isDataPending, isOrgPending, isCurrencyDataPending, isInfoPending])

  useEffect(() => {
    //setProfileData(null);
    /*axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.GetTransformerData",
            args: {
              type: "profile",
            },
          },
          id: 20,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result && res.data.result.Result) {
          setProfileData(res.data.result.Result);
          setIsLoaded(true);
          axios
            .post(
              apiRequestAddress,
              {
                jsonrpc: "2.0",
                method: "Data.GetEntityData",
                params: {
                  entity: "Countries",
                  filter: "EinvoicesOrder <> null",
                  orderBy: "EinvoicesOrder asc, CountryNameOriginal asc",
                  format: "Full",
                  "@nulls": false,
                },
                id: 35,
              },
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              // console.log(res.data.result.data);
              setCountriesList(res.data.result.data);
            });
        }
      });*/
  }, []);

  const onEditModeHandler = (isInMode) => {
    setIsEditMode(isInMode);
  };

  

  return (
    <div className={`h-100 w-100 p-5 ${classes.container}`}>
      {!isLoaded && (
        <LoadingDots className="w-100 h-100 d-flex align-items-center justify-content-center" />
      )}
      {isLoaded && profileData && (
        <>
          <ProfileDetails
            // orgTitle={companyData.Organization.Title || "default"}
            orgTitle={profileData.org.Name || "default"}
            onEditModeHandler={onEditModeHandler}
            isEditMode={true}
          />
          <Form
            profileData={profileData}
            isEditMode={isEditMode}
            onEditModeHandler={onEditModeHandler}
            countriesList={countriesList}
            currenciesList={currenciesList}
            hideSave = {hideSave}
            saveRef = {saveRef}
            entityInfo={entityInfo}
            refetch = {refetch}
          />
        </>
      )}
    </div>
  );
};

export default Profile;
